import script from "./UploadDrawModalRedesign.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadDrawModalRedesign.vue?vue&type=script&setup=true&lang=js"

import "./UploadDrawModalRedesign.vue?vue&type=style&index=0&id=41e57665&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e57665"]])

export default __exports__